import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../../../../../components/Header/Header';
import NoData from '../../../../../../components/NoData/NoData';
import Pagination from '../../../../../../components/Pagination/Pagination';
import { Loader } from '@piggytechng/component-library';
import { useDebounce } from '../../../../../../helpers/utils';
import useIpo from '../../../../../../hooks/useIpo';
import IpoOfferList from '../IpoOfferList';
import '../IpoTab.scss';

const ViewAllIpo = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [cursors, setCursors] = useState<Array<string | number | null>>([null]);
  const debouncedSearch = useDebounce(search, 400);

  useEffect(() => {
    setPage(1);
    setCursors([null]);
  }, [limit]);

  const cursor = cursors[page - 1] ?? null;
  const { investments, investmentsHasNextPage, investmentsEndCursor, isLoadingInvestments } = useIpo({
    fetchInvestments: true,
    investmentLimit: limit,
    cursor,
  });

  const query = debouncedSearch.toLowerCase();
  const offers = query
    ? investments.filter(
        (item) => item.offerName.toLowerCase().includes(query) || item.offerId.toLowerCase().includes(query),
      )
    : investments;

  return (
    <div className="ipo-tab ipo-view-all">
      <Header name="IPO Investments" backButton />
      <div className="content">
        <div className="ipo-tab__toolbar">
          <input
            className="ipo-tab__search"
            placeholder="Search by offer name or ID"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {isLoadingInvestments ? (
          <div className="ipo-tab__loader">
            <Loader color="#0F60D6" />
          </div>
        ) : offers.length > 0 ? (
          <>
            <IpoOfferList
              items={offers}
              onItemClick={(item) => navigate(`/view-ipo-offer/${id}/${item.offerId}`, { state: { offer: item } })}
            />
            <Pagination
              currentPage={page}
              hasNextPage={investmentsHasNextPage}
              hasPrevPage={page > 1}
              onNextPage={() => {
                if (investmentsEndCursor == null) return;
                setCursors((current) => {
                  const next = current.slice(0, page);
                  next.push(investmentsEndCursor);
                  return next;
                });
                setPage((current) => current + 1);
              }}
              onPrevPage={() => setPage((current) => Math.max(current - 1, 1))}
              limit={limit}
              onLimitChange={(newLimit) => setLimit(newLimit)}
            />
          </>
        ) : (
          <NoData message={search ? 'No IPO investments match your search.' : 'No IPO investments at the moment.'} />
        )}
      </div>
    </div>
  );
};

export default ViewAllIpo;
